// extracted by mini-css-extract-plugin
export default {"container":"_3c8VowPGffDIyGAdyfz-aG","text":"MobcS9Fxh0YVUcyv4EQEk","link":"_2y4fxRvQ2kP_mdSJivemL8","leftIcon":"_3IrdX8cd7VeeaJA7cHqZpK"};